/**
 * @file        src/lib/dateRules.js
 * @description Shared date-validation helpers for any form with an expiry /
 *              validity window: an expiry date may never be in the past, and
 *              an end date may never fall before its paired start date.
 *              Centralised so every admin form (discounts, coupons, and any
 *              future valid_from/valid_to pair) enforces the same rule the
 *              same way. Mirrored server-side by
 *              admin_backend/src/utils/dateRules.js (defense in depth).
 * @author      Kinetika Labs
 * @created     2026-08-10
 */

// Today as YYYY-MM-DD in LOCAL time — not toISOString(), which is UTC and can
// read as yesterday/tomorrow near midnight in IST.
export function todayStr() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Later of two 'YYYY-MM-DD' strings (blank-safe) — handy as a DatePicker `min`. */
export function laterDate(a, b) {
  if (!a) return b || '';
  if (!b) return a || '';
  return a > b ? a : b;
}

/** Error message if `dateStr` (YYYY-MM-DD) is a past date, else null. Blank passes. */
export function pastDateError(dateStr, label = 'Date') {
  if (!dateStr) return null;
  return dateStr < todayStr() ? `${label} cannot be in the past.` : null;
}

/** Error message if `to` is before `from` (YYYY-MM-DD), else null. Either blank passes. */
export function dateRangeError(from, to, fromLabel = 'Start Date', toLabel = 'End Date') {
  if (!from || !to) return null;
  return to < from ? `${toLabel} cannot be before ${fromLabel}.` : null;
}
